export default __webpack_public_path__ + "static/media/climate-bonds-standard.4fcd601a.jpg";